import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { ProgressBar } from '@/atoms/ProgressBar'
import { CaptionMD, CaptionSM } from '@/atoms/Text'
import { useIncrementer } from '@/services/GoalService/hooks/useIncrementer'
import { formatNumberForDisplay } from '@/utils/numbers'
import { useTranslate } from '@/utils/translate/translate-client'
import useTheatricalGoalService from '../../hooks/useTheatricalGoalService'

interface Props {
  className?: string
  theatricalSlug: string
  releaseDate: string
}

export const KidsGoFreeProgressBanner: React.FC<Props> = ({ theatricalSlug, releaseDate, className }) => {
  const { t } = useTranslate('tickets')

  const { goalLineInfo } = useTheatricalGoalService({
    theatricalSlug,
    releaseDate,
  })

  const { ticketsSold, currentMilestone, milestonePercentage } = goalLineInfo
  const ticketsIncrementerNumber = useIncrementer(ticketsSold, 0.9)
  const ticketsMilestonePercent = Math.round(useIncrementer(milestonePercentage, 0.9))

  return (
    <div className={classNames('relative bg-[#B5EAF1] py-3 pl-16 pr-4 text-[#141447] lg:pl-16', className)}>
      <Image
        src="/v1761163134/tali-img_phiub0"
        alt="Tali"
        width={91}
        height={117}
        className="absolute -left-4 top-1/2 -translate-y-1/2 lg:-left-5"
      />
      <div className="flex items-baseline justify-between">
        <CaptionMD weight="bold">
          {t('{{numTickets}} Tickets Sold', {
            numTickets: formatNumberForDisplay({ count: ticketsIncrementerNumber, format: '0,0' }),
          })}
        </CaptionMD>
        <CaptionMD>
          {t('percentOfMilestone', '{{percent}}% of Milestone', { percent: ticketsMilestonePercent })}
        </CaptionMD>
      </div>
      <ProgressBar barClassName="bg-[#5C428F]" className="my-1" value={ticketsMilestonePercent} />
      <CaptionSM italic>
        {t('ofMilestone', 'of {{ticketsMilestone}} Milestone', {
          ticketsMilestone: formatNumberForDisplay({ count: currentMilestone, format: '0,0' }),
        })}
      </CaptionSM>
    </div>
  )
}
